var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import mergeWith from "lodash-es/mergeWith.js";
import isNil from "lodash-es/isNil.js";
import has from "lodash-es/has.js";
import { DEFAULT_DATE_FORMAT } from "./date.js";
import transform from "lodash-es/transform.js";
import dayjs from "dayjs";
import isArray from "lodash-es/isArray.js";
function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
__name(sleep, "sleep");
function getRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
__name(getRandom, "getRandom");
const enumObject = /* @__PURE__ */ __name((e) => {
  const result = {};
  for (const key in e) {
    if (isNaN(parseInt(key, 10))) {
      result[key] = e[key];
    }
  }
  return result;
}, "enumObject");
const enumKeys = /* @__PURE__ */ __name((e) => {
  return Object.keys(enumObject(e));
}, "enumKeys");
const enumValues = /* @__PURE__ */ __name((e) => {
  return [...new Set(Object.values(enumObject(e)))];
}, "enumValues");
async function doUntil(task, {
  timeoutMs = 1e4,
  maxTry = 0,
  sleepMs = 1e3
}) {
  let result = void 0;
  let tryCnt = 0;
  let timedOut = false;
  let elapsed;
  let error;
  const dtStart = /* @__PURE__ */ new Date();
  do {
    ++tryCnt;
    const res = await task();
    if (res.isCompleted) {
      result = res.result;
      break;
    }
    error = res.error;
    elapsed = (/* @__PURE__ */ new Date()).getTime() - dtStart.getTime();
    timedOut = !!timeoutMs && timeoutMs <= elapsed;
    if (!!maxTry && maxTry <= tryCnt) {
      timedOut = true;
    }
    await sleep(sleepMs);
  } while (!timedOut);
  elapsed = (/* @__PURE__ */ new Date()).getTime() - dtStart.getTime();
  return [result, { timedOut, tryCnt, elapsed, error }];
}
__name(doUntil, "doUntil");
function isString(x) {
  return typeof x === "string";
}
__name(isString, "isString");
function isNumeric(num) {
  return num !== null && num !== "" && !isNaN(Number(num));
}
__name(isNumeric, "isNumeric");
function stringToNumber(obj) {
  return transform(obj, function(result, value, key) {
    result[key] = typeof value === "object" ? stringToNumber(value) : typeof value === "string" && isNumeric(value) ? Number(value) : value;
  });
}
__name(stringToNumber, "stringToNumber");
function isFunction(val) {
  return typeof val === "function";
}
__name(isFunction, "isFunction");
function getMatched(arr, value, defaultValue) {
  return arr.includes(value) ? value : defaultValue;
}
__name(getMatched, "getMatched");
function isIterable(obj) {
  return obj != null && typeof obj[Symbol.iterator] === "function";
}
__name(isIterable, "isIterable");
function mergeWithDefault(obj, src) {
  return mergeWith({}, obj, src, (objValue, srcValue) => {
    if (objValue === null || objValue === void 0) {
      return srcValue;
    }
    return objValue;
  });
}
__name(mergeWithDefault, "mergeWithDefault");
function mergeWithIncludingUndefined(obj, src) {
  const result = { ...obj };
  Object.keys(src).forEach((key) => {
    if (src.hasOwnProperty(key)) {
      result[key] = src[key];
    }
  });
  return result;
}
__name(mergeWithIncludingUndefined, "mergeWithIncludingUndefined");
function pickWithUndefined(obj, keys) {
  return keys.reduce(
    (result, key) => {
      result[key] = has(obj, key) ? obj[key] : void 0;
      return result;
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion, @typescript-eslint/consistent-type-assertions
    {}
  );
}
__name(pickWithUndefined, "pickWithUndefined");
function isNilOrNaN(value) {
  return isNil(value) || isNaN(Number(value));
}
__name(isNilOrNaN, "isNilOrNaN");
const timestampReplacer = /* @__PURE__ */ __name((obj) => {
  return transform(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    obj,
    function(result, value, key) {
      result[key] = typeof value === "object" ? timestampReplacer(value) : key.toString().endsWith("timestamp") || isNumeric(value) && Number(value) > 9466848e5 && Number(value) < 41338944e5 ? (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        dayjs(value).format(DEFAULT_DATE_FORMAT)
      ) : value;
    },
    isArray(obj) ? [] : {}
  );
}, "timestampReplacer");
export {
  doUntil,
  enumKeys,
  enumObject,
  enumValues,
  getMatched,
  getRandom,
  isFunction,
  isIterable,
  isNilOrNaN,
  isNumeric,
  isString,
  mergeWithDefault,
  mergeWithIncludingUndefined,
  pickWithUndefined,
  sleep,
  stringToNumber,
  timestampReplacer
};
//# sourceMappingURL=utils.js.map
